import { render, staticRenderFns } from "./AgendaPrazos.vue?vue&type=template&id=8dc39cfe&scoped=true&"
import script from "./AgendaPrazos.vue?vue&type=script&lang=js&"
export * from "./AgendaPrazos.vue?vue&type=script&lang=js&"
import style0 from "./AgendaPrazos.vue?vue&type=style&index=0&id=8dc39cfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc39cfe",
  null
  
)

export default component.exports